<style lang="less">
.dcGiveList {
  width: 6.9rem;
  margin: 0 auto;
  background: #fff;
  color: #000;
  border-radius: 0.04rem;
  &__title {
    h2 {
      font-size: 0.3rem;
      margin: 0;
      padding: .1rem 0 0;
      line-height: 2;
      text-align: center;
      font-weight: normal;
    }
  }
  &__body {
    width: 6.3rem;
    margin: 0 auto;
    padding: 0.2rem 0;
  }
}
</style>
<template>
  <div class="dcGiveList">
    <div class="dcGiveList__title"><h2>我的赠送</h2></div>
    <div class="dcGiveList__body">
      <dc-give-item
        v-for="item in giveAwards"
        :key="item.id"
        :item="item"
      ></dc-give-item>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DcGiveItem from './dc-give-item'
export default {
  name: 'dc-give-list',
  components: {
    DcGiveItem
  },
  computed: {
    ...mapState('laxin/dc', ['giveAwards'])
  }
}
</script>
